export interface ProjectsRemediationRateDetails {
  base: ProjectsRemediationRate;
  upstream: ProjectsRemediationRate;
}

export interface ProjectsRemediationRate {
  totalFixableIssues: number;
  totalOpenIssues: number;
  totalIssues: number;
  totalFixedIssues: number;
}
